module.exports = __webpack_public_path__ + "media/images/working-on-tyre-1589b5a4da568e77e62fe0bce95443cd.jpg";